import { Route } from 'react-router-dom'
import CareDelivery from 'screens/Reports/CareDelivery'
import CarePlanReportsDashboard from 'screens/Reports/CarePlans'
import RiskAssessmentDashboard from 'screens/Reports/RiskAssessmentDashboard/RiskAssessmentDashboard'
import MonitoringReports from 'screens/Reports/MonitoringReports/MonitoringReports'
import FluidsOverview from 'screens/Reports/Charts/charts/FluidsOverview'
import MealsOverview from 'screens/Reports/Charts/charts/MealsOverview'
import CoronavirusScreen from 'screens/Reports/Coronavirus/CoronavirusScreen'
import HandoversHistoryScreen from 'screens/Reports/Handovers/HandoversHistoryScreen'
import IncidentsReportScreen from 'screens/Reports/Incidents/IncidentsReportScreen'
import { IncidentsReportMainScreen } from 'screens/Reports/Incidents'
import MedicationRoundsReportScreen from 'screens/Reports/MedicationRounds/MedicationRoundsReportScreen'
import StockAlertsReportScreen from 'screens/Reports/StockAlerts'
import StockDiscrepanciesReportScreenWrapper from 'screens/Reports/StockDiscrepancies/StockDiscrepanciesReportScreenWrapper'
import ReportView from 'screens/Reports/ReportView'
import CurrentHandoverScreen from 'screens/Reports/Handovers/CurrentHandoverScreen'
import CQIReportScreen from 'screens/Reports/CQI'
import { TrainingMatrixScreen } from 'screens/Organisation/screens'
import { OccupancyScreen } from 'screens/Reports'
import { DownloadScreen } from 'screens/Reports/DownloadCentre'
import { AuditTrailScreen } from 'screens/Reports/AuditTrail'
import LogScreen from 'screens/Logs/LogScreen'
import GoalsManagement from '../../screens/Reports/Goals/GoalsManagement/GoalsManagement'
import GoalsDashboard from 'screens/Reports/Goals/GoalsDashboard/GoalsDashboard'
import RotaOverview from 'screens/Reports/RotaOverview/RotaOverview'
import BillingGapsReport from 'screens/Reports/screens/BillingGapsReport/BillingGapsReport'
import IncidentsActions from 'screens/Reports/Incidents/screens/IncidentsActions/IncidentsActions'
import IncidentReportEditCaseScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentReportEditCaseScreen'
import IncidentLogEditScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentLogEditScreen'
import IncidentReportCreateCaseScreen from 'screens/Logs/LogScreen/components/IncidentLogScreens/IncidentReportCreateCaseScreen'

export const REPORTS_PATH = 'reports'
export const FLUIDS = 'fluids'
export const MEALS = 'meals'
export const CORONAVIRUS = 'coronavirus'
export const OCCUPANCY_REPORT = 'occupancy-report'
export const CARE_DELIVERY = 'care-delivery'
export const HANDOVERS = 'handovers'
export const CURRENT = 'current'
export const HISTORY = 'history'
export const CARE_PLANS = 'care-plans'
export const CARE_PLANNING = 'care-planning'
export const INCIDENTS = 'incidents'
export const ACTIONS = 'incidents/actions'
export const ACTION_LOG = 'incidents/actions/:id'
export const ACTION_LOG_EDIT_CASE = 'incidents/actions/:id/edit-case'
export const ACTION_LOG_EDIT = 'incidents/actions/:id/edit'
export const EMAR = 'emar'
export const MEDICATION_ROUNDS = 'medication-rounds'
export const STOCK_DISCREPANCIES = 'stock-discrepancies'
export const STOCK_LEVELS = 'stock-levels'
export const CQI = 'cqi'
export const TRAINING_MATRIX = 'training-matrix'
export const RISK_ASSESSMENTS = 'risk-assessments'
export const MONITOR_REPORT = 'monitoring/:report'
export const DOWNLOAD_CENTRE = 'download-centre'
export const AUDIT_TRAIL = 'audit-trail'
export const INCIDENTS_REPORT = 'incidents/:report'
export const LOGS = 'incidents/list/:id'
export const LOGS_EDIT_CASE = 'incidents/list/:id/edit-case'
export const LOGS_EDIT = "incidents/list/:id/edit"
export const ACTION_LOG_CREATE_CASE = "incidents/list/:id/create-case"

export const ROSTERING = 'rostering'
export const ROTA_OVERVIEW = 'rota-overview'
export const BILLING_SETUP = 'billing-setup'

export const GOALS = 'goals'
export const GOALS_MANAGEMENT = 'goals-management'
export const GOALS_DASHBOARD = 'dashboard'

export const REPORTS = {
  INDEX: REPORTS_PATH,
  FLUIDS: `${REPORTS_PATH}/${FLUIDS}`,
  MEALS: `${REPORTS_PATH}/${MEALS}`,
  CORONAVIRUS: `${REPORTS_PATH}/${CORONAVIRUS}`,
  OCCUPANCY_REPORT: `${REPORTS_PATH}/${OCCUPANCY_REPORT}`,
  CARE_DELIVERY: `${REPORTS_PATH}/${CARE_DELIVERY}`,
  RISK_ASSESSMENTS: `${REPORTS_PATH}/${RISK_ASSESSMENTS}`,
  HANDOVERS_CURRENT: `${REPORTS_PATH}/${HANDOVERS}/${CURRENT}`,
  HANDOVERS_HISTORY: `${REPORTS_PATH}/${HANDOVERS}/${HISTORY}`,
  CARE_PLANS: `${REPORTS_PATH}/${CARE_PLANS}`,
  INCIDENTS: `${REPORTS_PATH}/${INCIDENTS}`,
  ACTIONS: `${REPORTS_PATH}/${ACTIONS}`,
  ACTION_LOG: `${REPORTS_PATH}/${ACTION_LOG}`,
  ACTION_LOG_EDIT_CASE: `${REPORTS_PATH}/${ACTION_LOG_EDIT_CASE}`,
  ACTION_LOG_CREATE_CASE: `${REPORTS_PATH}/${ACTION_LOG_CREATE_CASE}`,
  ACTION_LOG_EDIT: `${REPORTS_PATH}/${ACTION_LOG_EDIT}`,
  EMAR_MEDICATION_ROUNDS: `${REPORTS_PATH}/${EMAR}/${MEDICATION_ROUNDS}`,
  EMAR_STOCK_DISCREPANCIES: `${REPORTS_PATH}/${EMAR}/${STOCK_DISCREPANCIES}`,
  EMAR_STOCK_LEVELS: `${REPORTS_PATH}/${EMAR}/${STOCK_LEVELS}`,
  CQI: `${REPORTS_PATH}/${CQI}`,
  MONITOR_REPORT: `${REPORTS_PATH}/:report`,
  INCIDENTS_REPORT: `${REPORTS_PATH}/${INCIDENTS}/:report`,
  LOGS: `${REPORTS_PATH}/${LOGS}`,
  LOGS_EDIT_CASE: `${REPORTS_PATH}/${LOGS_EDIT_CASE}`,
  LOGS_EDIT: `${REPORTS_PATH}/${LOGS_EDIT}`,
  GOALS: `${REPORTS_PATH}/${GOALS}`,
}

export const reportsRoutes = (
  <Route path={REPORTS_PATH} element={<ReportView />}>
    <Route path={FLUIDS} element={<FluidsOverview />} />
    <Route path={MEALS} element={<MealsOverview />} />
    <Route path={CORONAVIRUS} element={<CoronavirusScreen />} />
    <Route path={OCCUPANCY_REPORT} element={<OccupancyScreen />} />
    <Route path={CARE_DELIVERY} element={<CareDelivery />} />
    <Route
      path={`${CARE_PLANNING}/${RISK_ASSESSMENTS}`}
      element={<RiskAssessmentDashboard type="riskAssessment" />}
    />
    <Route
      path={`${CARE_PLANNING}/${CARE_PLANS}`}
      element={<CarePlanReportsDashboard />}
    />
    <Route path={CARE_PLANS} element={<CarePlanReportsDashboard />} />
    <Route path={MONITOR_REPORT} element={<MonitoringReports />} />
    <Route
      path={`${HANDOVERS}/${CURRENT}`}
      // @ts-ignore
      element={<CurrentHandoverScreen />}
    />
    <Route
      path={`${HANDOVERS}/${HISTORY}`}
      element={<HandoversHistoryScreen />}
    />
    <Route path={INCIDENTS} element={<IncidentsReportScreen />} />
	<Route path={ACTIONS} element={<IncidentsActions />} />
	<Route path={ACTION_LOG} element={<LogScreen />} />
	<Route
      path={ACTION_LOG_EDIT_CASE}
      element={<IncidentReportEditCaseScreen />}
    />
	<Route
      path={ACTION_LOG_CREATE_CASE}
      element={<IncidentReportCreateCaseScreen />}
    />
	<Route path={ACTION_LOG_EDIT} element={<IncidentLogEditScreen />} />
    <Route path={LOGS} element={<LogScreen />} />
	<Route
      path={LOGS_EDIT_CASE}
      element={<IncidentReportEditCaseScreen />}
    />
	<Route path={LOGS_EDIT} element={<IncidentLogEditScreen />} />
    <Route path={INCIDENTS_REPORT} element={<IncidentsReportMainScreen />} />
    <Route
      path={`${GOALS}/${GOALS_MANAGEMENT}`}
      element={<GoalsManagement />}
    />
    <Route path={`${GOALS}/${GOALS_DASHBOARD}`} element={<GoalsDashboard />} />
    <Route
      path={`${EMAR}/${MEDICATION_ROUNDS}`}
      element={<MedicationRoundsReportScreen />}
    />
    <Route
      path={`${EMAR}/${STOCK_DISCREPANCIES}`}
      element={<StockDiscrepanciesReportScreenWrapper />}
    />
    <Route
      path={`${EMAR}/${STOCK_LEVELS}`}
      // @ts-ignore
      element={<StockAlertsReportScreen />}
    />
    {/* @ts-ignore */}
    <Route path={CQI} element={<CQIReportScreen />} />
    <Route path={TRAINING_MATRIX} element={<TrainingMatrixScreen />} />
    <Route path={DOWNLOAD_CENTRE} element={<DownloadScreen />} />
    <Route path={`${ROSTERING}/${ROTA_OVERVIEW}`} element={<RotaOverview />} />
    <Route path={BILLING_SETUP} element={<BillingGapsReport />} />
    <Route path={AUDIT_TRAIL} element={<AuditTrailScreen />} />
  </Route>
)
